import { useTranslation } from 'react-i18next'

interface IProps {
  priceAnalysis: any
}
export default function PriceTooltip({ priceAnalysis }: IProps) {
  const { t } = useTranslation()

  return (
    <>
      {priceAnalysis && !!priceAnalysis['Hours'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.hours') + ': ' + priceAnalysis['Hours']} *</span>
          <span>{priceAnalysis['Amount']}€</span>
          <span>= {priceAnalysis['Price'].toFixed(2)}€</span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Festivity Price'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.festivities') + ': ' + priceAnalysis['Festivity Price']}€</span>
        </div>
      )}
      {/*{priceAnalysis && !!priceAnalysis['Morning Hours'] && (
          <div className="flex gap-1 font-bold">
            <span>{t('price.morning_hours') + ': ' + priceAnalysis['Morning Hours']} *</span>
            <span>{priceAnalysis['Morning Amount']}€</span>
            <span>= {priceAnalysis['Morning Price']}€</span>
          </div>
        )}
        {priceAnalysis && !!priceAnalysis['Festivities Price Morning'] && (
          <div className="flex gap-1 font-bold">
            <span>
              {t('price.festivities_morning') + ': ' + priceAnalysis['Festivities Price Morning']}€
            </span>
          </div>
        )}
        {priceAnalysis && !!priceAnalysis['Evening Hours'] && (
          <div className="flex gap-1 font-bold">
            <span>{t('price.evening_hours') + ': ' + priceAnalysis['Evening Hours']} *</span>
            <span>{priceAnalysis['Evening Amount']}€</span>
            <span>= {priceAnalysis['Evening Price']}€</span>
          </div>
        )}
        {priceAnalysis && !!priceAnalysis['Festivities Price Evening'] && (
          <div className="flex gap-1 font-bold">
            <span>
              {t('price.festivities_evening') + ': ' + priceAnalysis['Festivities Price Evening']}€
            </span>
          </div>
        )}*/}
      {priceAnalysis && !!priceAnalysis['Setup Hours'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.setup_hours') + ': ' + priceAnalysis['Setup Hours']}</span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Babysitters'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.babysitters') + ': ' + priceAnalysis['Babysitters']}</span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Extra Activites'] && (
        <div className="flex gap-1 font-bold">
          <span>
            {t('price.extra_activities') + ': ' + priceAnalysis['Extra Activites'].toFixed(2)}€
          </span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Entertainment Kit'] && (
        <div className="flex gap-1 font-bold">
          <span>
            {t('price.entertainment_kit') + ': ' + priceAnalysis['Entertainment Kit'].toFixed(2)}€
          </span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Distance Price'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.mileage_fee') + ': ' + priceAnalysis['Distance Price'].toFixed(2)}€</span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Urgency Fee'] && (
        <div className="flex gap-1 font-bold">
          <span>
            {t('price.urgency_fee') + ': ' + Number(priceAnalysis['Urgency Fee']).toFixed(2)}€
          </span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Special Needs Fee'] && (
        <div className="flex gap-1 font-bold">
          <span>
            {t('price.special_needs_fee') +
              ': ' +
              Number(priceAnalysis['Special Needs Fee']).toFixed(2)}
            €
          </span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Bonus'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.bonus') + ': ' + priceAnalysis['Bonus'].toFixed(2)}€</span>
        </div>
      )}
      {priceAnalysis && !!priceAnalysis['Vat Amount'] && (
        <div className="flex gap-1 font-bold">
          <span>{t('price.vat') + ': ' + priceAnalysis['Vat Amount'].toFixed(2)}€</span>
        </div>
      )}
      {priceAnalysis &&
        !!priceAnalysis['pricesPerMonth'] &&
        Object.keys(priceAnalysis['pricesPerMonth']).length > 1 && (
          <>
            <div className="flex gap-1 mt-2 font-bold">
              <span>{t('price.per_month') + ''}</span>
            </div>
            {Object.keys(priceAnalysis['pricesPerMonth']).map((key, index) => (
              <>
                {index > 0 && (
                  <div key={index} className="flex gap-1 font-bold">
                    <span>
                      {t('month') + ' '}
                      {key + ': ' + priceAnalysis['pricesPerMonth'][key].toFixed(2)}€
                    </span>
                  </div>
                )}
              </>
            ))}
          </>
        )}
    </>
  )
}
